import { render, staticRenderFns } from "./ImageCropping.vue?vue&type=template&id=61bf2067"
import script from "./ImageCropping.vue?vue&type=script&lang=js"
export * from "./ImageCropping.vue?vue&type=script&lang=js"
import style0 from "./ImageCropping.vue?vue&type=style&index=0&id=61bf2067&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports